import { render, staticRenderFns } from "./FormArrayValidationGroup.vue?vue&type=template&id=21531bf1&"
import script from "./FormArrayValidationGroup.vue?vue&type=script&lang=js&"
export * from "./FormArrayValidationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports